import script from "./commentField.vue?vue&type=script&setup=true&lang=ts"
export * from "./commentField.vue?vue&type=script&setup=true&lang=ts"

import "./commentField.vue?vue&type=style&index=0&id=77fa4690&lang=css"

const __exports__ = script;

export default __exports__